'use client';

import Link from 'next/link';
import { ChevronDown, MobileDevice } from '@/components/pages/icons';
import Cta from '@/components/pages/cta';
import { MobileSubmenuLink } from './mobile-submenu-link';
import type { SubmenuProp } from './type';

export function MobileSubMenu({ submenu, ctaHref, onClickCta, navLinks }: SubmenuProp) {
  return (
    <nav data-menu className="hidden group-open:flex group-open:@lg:hidden flex-col">
      <ul className="divide-y px-2 flex flex-col divide-black/20 text-[#172554]">
        <li className="font-serif text-[52px] italic leading-[110%] tracking-[-1.04px] p-4">
          Menu
        </li>

        {(navLinks || []).map((item) =>
          item.isClaimSections ? (
            <li key={`mobile-${item.label}`}>
              <details className="group/details">
                <summary className="text-[32px] leading-[120%] tracking-[-0.96px] px-4 py-6 flex justify-between w-full items-center cursor-pointer">
                  <span>{item.label}</span>
                  <ChevronDown className="w-6 h-6 text-brand-accent transition-transform duration-300 ease-in-out group-open/details:-rotate-180" />
                </summary>
                <div className="px-4 pb-6 max-h-[300px] overflow-y-auto">
                  <ul className="grid grid-cols-2 gap-4">
                    {submenu.map((item) => (
                      <li key={`mobile-${item.label}`}>
                        <Link
                          className="text-brand-text-button text-xl leading-[130%] tracking-[-0.4px] hover:brightness-90"
                          href={item.url}
                        >
                          {item.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </details>
            </li>
          ) : (
            <MobileSubmenuLink
              key={`mobile-${item.label}`}
              label={item.label}
              href={item.href || '#'}
            />
          )
        )}

        <li className="px-4 py-3">
          <Cta
            size="md"
            variation="outline"
            text="Free case review"
            iconSide="left"
            icon={<MobileDevice />}
            className="w-full"
            onClick={onClickCta}
            href={ctaHref}
          />
        </li>
      </ul>
    </nav>
  );
}
